import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FileText, Wallet, Clock, Target, MessageCircle, CheckSquare, Calendar } from 'lucide-react';
const items = [{
  icon: BookOpen,
  text: 'Ebook + Guía completa del método'
}, {
  icon: FileText,
  text: 'Plantillas listas para usar'
}, {
  icon: Wallet,
  text: "Método 3 sobres + 'por si las dudas'"
}, {
  icon: Clock,
  text: 'Regla anti-antojos 24h'
}, {
  icon: Target,
  text: 'Plan de deuda: mínimo + ataque'
}, {
  icon: MessageCircle,
  text: 'Frases para poner límites (copiar/pegar)'
}, {
  icon: CheckSquare,
  text: 'Checklist de inicio rápido'
}, {
  icon: Calendar,
  text: 'Checklist quincenal recurrente'
}];
export function WhatsIncluded() {
  return <section className="py-12 bg-gradient-to-br from-brand-cream to-white" data-id="element-260">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-261">
        <div className="text-center mb-12" data-id="element-262">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-263">
            Todo lo que incluye tu plan
          </h2>
          <p className="font-sans text-lg text-brand-text/70 max-w-2xl mx-auto" data-id="element-264">
            Herramientas prácticas para que tu dinero deje de desaparecer
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-265">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white p-6 rounded-2xl border-2 border-brand-green/10 hover:border-brand-green/30 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-266">
                <div className="flex items-center gap-4" data-id="element-267">
                  <div className="flex-shrink-0 w-14 h-14 bg-brand-green/10 rounded-xl flex items-center justify-center" data-id="element-268">
                    <Icon className="w-7 h-7 text-brand-green" strokeWidth={2} data-id="element-269" />
                  </div>
                  <p className="font-sans text-base md:text-lg text-brand-dark font-medium leading-snug" data-id="element-270">
                    {item.text}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Price Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="max-w-md mx-auto" data-id="element-271">
          <div className="bg-gradient-to-br from-brand-green to-brand-dark p-8 rounded-2xl shadow-xl text-center text-white relative overflow-hidden" data-id="element-272">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-2xl" data-id="element-273"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full blur-xl" data-id="element-274"></div>

            <div className="relative z-10" data-id="element-275">
              <span className="block font-heading text-6xl font-bold text-brand-gold mb-2" data-id="element-276">
                $8.97
              </span>
              <span className="block font-sans text-sm opacity-80 mb-6" data-id="element-277">
                USD • Pago único • Acceso inmediato
              </span>
              <button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full bg-white text-brand-green font-heading font-bold py-4 px-8 rounded-xl hover:bg-brand-cream transition-all transform hover:scale-[1.02] shadow-lg" data-id="element-278">
                Lo quiero ahora
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}